import React, { useState } from "react";
import { smallTopBtnStyle } from "../../styles/commonStyles";

export default function TopBarActions({
  onPrev,
  onStar,
  onSkip,
  onHome,
  disablePrev = false,
  // 新增：支持外部传入初始星标状态（可选）
  isStarred = false,
}) {
  // 本地维护星标激活状态（优先使用外部传入的初始值）
  const [starActive, setStarActive] = useState(isStarred);

  // 星标点击逻辑：切换状态 + 执行外部回调
  const handleStarClick = () => {
    const newState = !starActive;
    setStarActive(newState);
    // 把最新状态传给父组件（方便做收藏/取消收藏的逻辑）
    onStar?.(newState);
  };

  return (
    <div style={{ display: "flex", gap: "0.55rem", alignItems: "center" }}>
      <button
        title="返回上一个单词"
        onClick={onPrev}
        disabled={disablePrev}
        style={{
          ...smallTopBtnStyle("#E9EEF5"),
          opacity: disablePrev ? 0.45 : 1,
          cursor: disablePrev ? "not-allowed" : "pointer",
        }}
      >
        ↩
      </button>

      {/* 改造星标按钮：空心/实心切换 */}
      <button
        title={starActive ? "移除单词本" : "加入单词本"} // 提示文字同步切换
        onClick={handleStarClick} // 替换原 onClick 为自定义逻辑
        style={{
          ...smallTopBtnStyle("#FFF4D9"),
          // 可选：激活时加深背景色，强化视觉反馈（也可以不加）
          background: starActive ? "#FFE699" : smallTopBtnStyle("#FFF4D9").background,
          transition: "background 0.2s ease", // 过渡动画
        }}
      >
        {/* 核心：空心☆ / 实心★ 切换 */}
        {starActive ? "★" : "☆"}
      </button>

      <button title="跳过" onClick={onSkip} style={smallTopBtnStyle("#EAF8EE")}>
        ⏭
      </button>

      <button title="返回主页" onClick={onHome} style={smallTopBtnStyle("#F3F4F6")}>
        ⌂
      </button>
    </div>
  );
}